export default __webpack_public_path__ + "static/media/icons-category-reward.40f0185d.svg";